import axios from 'axios';
import { BASE_URL } from '../config/config';

// const URL = 'http://localhost:3000/users';
const URL = BASE_URL + '/users';

const loginUser = async (data) => {
  try {
    const result = await axios.post(`${URL}/login`, data);

    const access_token = result.data.access_token;
    console.log(access_token);
    localStorage.setItem('access_token', access_token);
    // axios.defaults.headers.common['access_token'] = access_token;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message); // Lempar kesalahan jika ada
    } else {
      throw new Error(
        'An error occurred while logging in. Please try again later.'
      );
    }
  }
};

const getUserList = async (keyword, page, limit) => {
  try {
    const response = await axios.get(URL, {
      params: {
        keyword,
        page,
        limit,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
const createUser = async (data) => {
  try {
    const result = await axios.post(URL, data);
    console.log(result);
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message); // Lempar kesalahan jika ada
    } else {
      throw new Error('There was an error creating the user.');
    }
  }
};

const updateUser = async (id, data) => {
  try {
    await axios.put(`${URL}/${id}`, data);
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message); // Lempar kesalahan jika ada
    } else {
      throw new Error('There was an error updating the user.');
    }
  }
};

const deleteUser = async (id) => {
  try {
    await axios.delete(`${URL}/${id}`);
  } catch (error) {
    console.log(error);
  }
};

const getUserById = async (id) => {
  try {
    const result = await axios.get(`${URL}/${id}`);
    return result.data;
  } catch (error) {
    console.log(error);
  }
};

export {
  loginUser,
  createUser,
  deleteUser,
  getUserById,
  getUserList,
  updateUser,
};
